"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListTitle = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _List = require("../NavigationList/List.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var ListTitle = exports.ListTitle = _styledComponents["default"].dt.withConfig({
  displayName: "ListTitle",
  componentId: "sc-p72r5i-0"
})(["", " color:var(--text-subdued,", ");margin-block-end:", ";margin-inline:", ";", " ", " &{margin-inline-start:", ";}&:not(:first-child){@media (min-width:", "){margin-block-start:", ";}}@media (max-width:", "){display:none;}"], (0, _index.rootStyle)(), _index.defaultColorSet.text.subdued, (0, _index.cssSpacing)('tighter-4', '4px'), (0, _index.cssLayoutMargin)('tighter', '24px'), _List.List, _List.List, (0, _index.cssSpacing)('looser-3', '40px'), _encoreFoundation.screenSmMin, (0, _index.cssSpacing)('looser', '24px'), _encoreFoundation.screenXsMax);